<template>
    <ModalWrapper v-model="isShowModal">
        <template v-slot:activator>
            <slot name="activator" />
        </template>
        <template v-slot:title>{{ $t('manager') }}</template>
        <template v-slot:content>
            <div class="text-subtitle-1">
                <div v-if="manager?.name" class="d-table-row">
                    <div class="d-table-cell pr-4">{{ $t('name') }}:</div>
                    <div class="d-table-cell">{{ manager.name }}</div>
                </div>
                <div v-if="manager?.contactPhone" class="d-table-row">
                    <div class="d-table-cell pr-4">{{ $t('phone') }}:</div>
                    <div class="d-table-cell">{{ manager.contactPhone }}</div>
                </div>
                <div v-if="manager?.email" class="d-table-row">
                    <div class="d-table-cell pr-4">{{ $t('email') }}:</div>
                    <div class="d-table-cell">{{ manager.email }}</div>
                </div>
                <div v-if="manager?.skype" class="d-table-row">
                    <div class="d-table-cell pr-4">{{ $t('skype') }}:</div>
                    <div class="d-table-cell">{{ manager.skype }}</div>
                </div>
                <div v-if="manager?.icq" class="d-table-row">
                    <div class="d-table-cell pr-4">{{ $t('messenger') }}:</div>
                    <div class="d-table-cell">{{ manager.icq }}</div>
                </div>
            </div>
        </template>
    </ModalWrapper>
</template>
<script setup lang="ts">
    defineProps<{
        manager: any
    }>()

    const isShowModal = defineModel<boolean>()
</script>
